import { useState } from 'react'
import { IListIndustry } from 'data-transfers/dto'

interface ExpandableIndustriesProps {
  industries: IListIndustry[]
}

const ExpandableIndustries = ({ industries }: ExpandableIndustriesProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className={'flex flex-wrap gap-x-2 gap-y-2'}>
      {industries.slice(0, 3).map((i) => (
        <span
          key={i.id}
          className={'rounded-full border border-gray-300 px-4 py-2'}
        >
          {i.value}
        </span>
      ))}

      {industries.length > 3 && !expanded && (
        <span
          className={
            'cursor-pointer rounded-full border border-gray-300 hover:bg-gray-50 px-4 py-2'
          }
          onClick={() => setExpanded(true)}
        >
          {industries.length - 3}+
        </span>
      )}

      {industries.length > 3 &&
        expanded &&
        industries.slice(3).map((i) => {
          return (
            <span
              key={i.id}
              className={
                'cursor-pointer rounded-full border border-gray-300 hover:bg-gray-50 px-4 py-2'
              }
              onClick={() => setExpanded(false)}
            >
              {i.value}
            </span>
          )
        })}
    </div>
  )
}
export default ExpandableIndustries
